module.exports = __webpack_public_path__ + "static/img/bg-en.c49ea3f3.png";